import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Shared Pages
import Login from './pages/shared/Login';
import Profile from './pages/shared/Profile'; 

// Admin/Staff Pages
import AdminDashboard from './pages/admin/Dashboard'; 
import Residents from './pages/admin/Residents'; 
import Billing from './pages/admin/Billing'; 
import AdminAnnouncements from './pages/admin/Announcements';
import Expenses from './pages/admin/Expenses';
import Reports from './pages/admin/Reports';
import AdminComplaints from './pages/admin/Complaints'; 

// Super Admin Pages
import UserManagement from './pages/superadmin/UserManagement';
import ActionLogs from './pages/superadmin/ActionLogs';
// --- IMPORT BACKUP COMPONENT ---
import Backup from './components/Backup'; 

// Resident Pages
import ResidentDashboard from './pages/resident/ResidentDashboard';
import ResidentTickets from './pages/resident/ResidentTickets';

// Helper function to check authentication and role
const ProtectedRoute = ({ element: Element, ...rest }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  
  if (!user || !user.token) {
    return <Navigate to="/login" replace />;
  }
  
  const role = user.role;
  const path = rest.path;

  // 1. Resident Access Control
  if (role === 'resident') {
      const allowed = ['/resident-dashboard', '/announcements', '/resident-tickets', '/profile'];
      if (!allowed.includes(path)) {
          return <Navigate to="/resident-dashboard" replace />;
      }
  }

  // 2. Admin/Staff Access Control (Cannot access resident or super admin pages)
  if ((role === 'admin' || role === 'staff')) {
      const residentPages = ['/resident-dashboard', '/resident-tickets'];
      // Ensure /backup is restricted here
      const superAdminPages = ['/user-management', '/action-logs', '/backup']; 
      
      if (residentPages.includes(path)) {
          return <Navigate to="/dashboard" replace />;
      }
      if (superAdminPages.includes(path)) {
          return <Navigate to="/dashboard" replace />;
      }
  }

  return <Element {...rest} />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        
        {/* --- Admin/Staff Routes --- */}
        <Route path="/dashboard" element={<ProtectedRoute element={AdminDashboard} path="/dashboard" />} />
        <Route path="/residents" element={<ProtectedRoute element={Residents} path="/residents" />} />
        <Route path="/billing" element={<ProtectedRoute element={Billing} path="/billing" />} /> 
        <Route path="/expenses" element={<ProtectedRoute element={Expenses} path="/expenses" />} />
        <Route path="/reports" element={<ProtectedRoute element={Reports} path="/reports" />} />
        <Route path="/complaints" element={<ProtectedRoute element={AdminComplaints} path="/complaints" />} />
        <Route path="/announcements" element={<ProtectedRoute element={AdminAnnouncements} path="/announcements" />} />

        {/* --- Super Admin Routes --- */}
        <Route path="/user-management" element={<ProtectedRoute element={UserManagement} path="/user-management" />} />
        <Route path="/action-logs" element={<ProtectedRoute element={ActionLogs} path="/action-logs" />} />
        {/* --- ADD BACKUP ROUTE --- */}
        <Route path="/backup" element={<ProtectedRoute element={Backup} path="/backup" />} />

        {/* --- Resident Routes --- */}
        <Route path="/resident-dashboard" element={<ProtectedRoute element={ResidentDashboard} path="/resident-dashboard" />} />
        <Route path="/resident-tickets" element={<ProtectedRoute element={ResidentTickets} path="/resident-tickets" />} />
        
        {/* --- Shared Routes --- */}
        <Route path="/profile" element={<ProtectedRoute element={Profile} path="/profile" />} />
        
      </Routes>
    </Router>
  );
}

export default App;